import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgModelScale = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 109.171,
	height: 85.469,
	viewBox: "0 0 109.171 85.469",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".custom-rect{display:inline !important;}" }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Edit-Bottom",
		transform: "translate(-476.186 -615.771)",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_16893",
				"data-name": "Group 16893",
				transform: "translate(476.194 637.705)",
				opacity: .2,
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Path_12550",
					"data-name": "Path 12550",
					d: "M6,17V30.273",
					transform: "translate(3.955 29.456)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 3
				}), /* @__PURE__ */ _jsx("path", {
					id: "Path_12551",
					"data-name": "Path 12551",
					d: "M4,19H17.273",
					transform: "translate(-0.682 34.093)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 3
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_16894",
				"data-name": "Group 16894",
				transform: "translate(504.442 617.271)",
				opacity: .2,
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Path_12552",
					"data-name": "Path 12552",
					d: "M17,3v9.773",
					transform: "translate(27.706 -3)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 3
				}), /* @__PURE__ */ _jsx("path", {
					id: "Path_12553",
					"data-name": "Path 12553",
					d: "M15,5h9.773",
					transform: "translate(24.82 -0.114)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 3
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_16895",
				"data-name": "Group 16895",
				transform: "translate(524.127 641.76)",
				opacity: .2,
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_12558",
						"data-name": "Path 12558",
						d: "M11.609,26.662A15.579,15.579,0,0,0,27.188,11.083",
						transform: "translate(16.958 15.739)",
						fill: "none",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 3
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_12559",
						"data-name": "Path 12559",
						d: "M16.305,11.083A15.579,15.579,0,0,0,31.884,26.662",
						transform: "translate(27.845 15.739)",
						fill: "none",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 3
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_12560",
						"data-name": "Path 12560",
						d: "M31.884,15.778A15.579,15.579,0,0,0,16.305,31.357",
						transform: "translate(27.845 26.623)",
						fill: "none",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 3
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_12561",
						"data-name": "Path 12561",
						d: "M27.189,31.357A15.579,15.579,0,0,0,11.61,15.778",
						transform: "translate(16.96 26.623)",
						fill: "none",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 3
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "ic.scale",
				transform: "translate(504.035 640.797)",
				opacity: .5,
				children: [/* @__PURE__ */ _jsx("rect", {
					className: "custom-rect",
					id: "Rectangle_Copy_4",
					"data-name": "Rectangle Copy 4",
					width: 50,
					height: 50,
					fill: "none"
				}), /* @__PURE__ */ _jsxs("g", {
					id: "Group",
					transform: "translate(6.25 8.333)",
					children: [
						/* @__PURE__ */ _jsxs("g", {
							id: "Rectangle",
							transform: "translate(0 0)",
							fill: "none",
							stroke: "currentColor",
							strokeWidth: 3,
							children: [/* @__PURE__ */ _jsx("rect", {
								className: "custom-rect",
								width: 37.5,
								height: 35.417,
								rx: 2,
								stroke: "none"
							}), /* @__PURE__ */ _jsx("rect", {
								className: "custom-rect",
								x: 1.5,
								y: 1.5,
								width: 34.5,
								height: 32.417,
								rx: .5,
								fill: "none"
							})]
						}),
						/* @__PURE__ */ _jsxs("g", {
							id: "Oval",
							transform: "translate(8.333 0)",
							fill: "none",
							children: [/* @__PURE__ */ _jsx("path", {
								d: "M10.417,0A10.417,10.417,0,1,1,0,10.417,10.417,10.417,0,0,1,10.417,0Z",
								stroke: "none"
							}), /* @__PURE__ */ _jsx("path", {
								d: "M 10.41666698455811 2.999996185302734 C 6.327096939086914 2.999996185302734 2.999996185302734 6.327096939086914 2.999996185302734 10.41666698455811 C 2.999996185302734 14.5062370300293 6.327096939086914 17.83333778381348 10.41666698455811 17.83333778381348 C 14.5062370300293 17.83333778381348 17.83333778381348 14.5062370300293 17.83333778381348 10.41666698455811 C 17.83333778381348 6.327096939086914 14.5062370300293 2.999996185302734 10.41666698455811 2.999996185302734 M 10.41666698455811 -3.814697265625e-06 C 16.16963768005371 -3.814697265625e-06 20.83333778381348 4.6636962890625 20.83333778381348 10.41666698455811 C 20.83333778381348 16.16963768005371 16.16963768005371 20.83333778381348 10.41666698455811 20.83333778381348 C 4.6636962890625 20.83333778381348 -3.814697265625e-06 16.16963768005371 -3.814697265625e-06 10.41666698455811 C -3.814697265625e-06 4.6636962890625 4.6636962890625 -3.814697265625e-06 10.41666698455811 -3.814697265625e-06 Z",
								stroke: "none",
								fill: "currentColor"
							})]
						}),
						/* @__PURE__ */ _jsxs("g", {
							id: "Rectangle-2",
							"data-name": "Rectangle",
							transform: "translate(16.667 6.25)",
							fill: "none",
							stroke: "currentColor",
							strokeWidth: 3,
							children: [/* @__PURE__ */ _jsx("rect", {
								className: "custom-rect",
								width: 4.167,
								height: 6.25,
								stroke: "none"
							}), /* @__PURE__ */ _jsx("rect", {
								className: "custom-rect",
								x: 1.5,
								y: 1.5,
								width: 1.167,
								height: 3.25,
								fill: "none"
							})]
						})
					]
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "ic.ruler",
				transform: "matrix(0.839, 0.545, -0.545, 0.839, 489.257, 624.621)",
				opacity: .5,
				children: [/* @__PURE__ */ _jsx("rect", {
					className: "custom-rect",
					id: "Rectangle-3",
					"data-name": "Rectangle",
					width: 24,
					height: 24,
					fill: "none"
				}), /* @__PURE__ */ _jsxs("g", {
					id: "Group-2",
					"data-name": "Group",
					transform: "translate(4 3)",
					children: [
						/* @__PURE__ */ _jsxs("g", {
							id: "Rectangle-4",
							"data-name": "Rectangle",
							fill: "none",
							stroke: "currentColor",
							strokeWidth: 1,
							children: [/* @__PURE__ */ _jsx("rect", {
								className: "custom-rect",
								width: 8,
								height: 18,
								rx: 2,
								stroke: "none"
							}), /* @__PURE__ */ _jsx("rect", {
								className: "custom-rect",
								x: .5,
								y: .5,
								width: 7,
								height: 17,
								rx: 1.5,
								fill: "none"
							})]
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_3",
							"data-name": "Path 3",
							d: "M2,0,0,2.5H4Z",
							transform: "translate(11 0.5)",
							fill: "currentColor",
							stroke: "currentColor",
							strokeLinejoin: "round",
							strokeWidth: 1
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_3_Copy",
							"data-name": "Path 3 Copy",
							d: "M2,0,0-2.5H4Z",
							transform: "translate(11 17.5)",
							fill: "currentColor",
							stroke: "currentColor",
							strokeLinejoin: "round",
							strokeWidth: 1
						}),
						/* @__PURE__ */ _jsxs("g", {
							id: "Rectangle-5",
							"data-name": "Rectangle",
							transform: "translate(4 13)",
							fill: "none",
							stroke: "currentColor",
							strokeWidth: 1,
							children: [/* @__PURE__ */ _jsx("rect", {
								className: "custom-rect",
								width: 4,
								height: 1,
								stroke: "none"
							}), /* @__PURE__ */ _jsx("rect", {
								className: "custom-rect",
								x: .5,
								y: .5,
								width: 3,
								fill: "none"
							})]
						}),
						/* @__PURE__ */ _jsxs("g", {
							id: "Rectangle_Copy",
							"data-name": "Rectangle Copy",
							transform: "translate(4 10)",
							fill: "none",
							stroke: "currentColor",
							strokeWidth: 1,
							children: [/* @__PURE__ */ _jsx("rect", {
								className: "custom-rect",
								width: 4,
								height: 1,
								stroke: "none"
							}), /* @__PURE__ */ _jsx("rect", {
								className: "custom-rect",
								x: .5,
								y: .5,
								width: 3,
								fill: "none"
							})]
						}),
						/* @__PURE__ */ _jsxs("g", {
							id: "Rectangle_Copy_2",
							"data-name": "Rectangle Copy 2",
							transform: "translate(4 7)",
							fill: "none",
							stroke: "currentColor",
							strokeWidth: 1,
							children: [/* @__PURE__ */ _jsx("rect", {
								className: "custom-rect",
								width: 4,
								height: 1,
								stroke: "none"
							}), /* @__PURE__ */ _jsx("rect", {
								className: "custom-rect",
								x: .5,
								y: .5,
								width: 3,
								fill: "none"
							})]
						}),
						/* @__PURE__ */ _jsxs("g", {
							id: "Rectangle_Copy_3",
							"data-name": "Rectangle Copy 3",
							transform: "translate(4 4)",
							fill: "none",
							stroke: "currentColor",
							strokeWidth: 1,
							children: [/* @__PURE__ */ _jsx("rect", {
								className: "custom-rect",
								width: 4,
								height: 1,
								stroke: "none"
							}), /* @__PURE__ */ _jsx("rect", {
								className: "custom-rect",
								x: .5,
								y: .5,
								width: 3,
								fill: "none"
							})]
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_2_Copy",
							"data-name": "Path 2 Copy",
							d: "M.5,0V14",
							transform: "translate(12.5 2)",
							fill: "none",
							stroke: "currentColor",
							strokeWidth: 1
						})
					]
				})]
			})
		]
	})]
});
export default SvgModelScale;
